import cn from 'classnames';

import SidebarMenu from 'components/menu/SidebarMenu.component';
import ClientTagsSplashBottomPanel from 'components/tags/splash/ClientTagsSplashBottomPanel.component';
import ClientTagsSplashTopPanel from 'components/tags/splash/ClientTagsSplashTopPanel.component';
import useWindowScroll from 'hooks/useWindowScroll.hook';
import { useTheme } from 'providers/Theme.provider';

import PadLock from 'lib/components/PadLock';

import CN from './ClientTagsSplashPage.module.scss';

const ClientTagsSplashPage = () => {
  const { isBrightMode, isDarkMode, isLightMode } = useTheme();
  useWindowScroll(0, 0);

  return (
    <div
      data-bem="ClientTagsSplashPage"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        'light-class': isLightMode,
        'dark-class': isDarkMode,
        'bright-class': isBrightMode,
      })}
    >
      <header data-bem="ClientTagsSplashPage__header" className={CN.header}>
        <SidebarMenu />
        <div className={CN.globalNav}>
          <div className={cn(CN.pageName, CN.clientTags)} />
          <nav className={CN.menuList}>
            <ul className={CN.ulScrollMenu} />
          </nav>
        </div>
        <PadLock />
      </header>

      <ClientTagsSplashTopPanel />
      <ClientTagsSplashBottomPanel />
    </div>
  );
};

export default ClientTagsSplashPage;
